module.exports = __webpack_public_path__ + "img/DANY_BRILLANT_15s.6f9b9e82.jpg";